import { render } from "./count.vue?vue&type=template&id=83aab968&scoped=true"
import script from "./count.vue?vue&type=script&lang=js"
export * from "./count.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-83aab968"

export default script